export default "__VITE_ASSET__b232dada__"